import React from "react";

export const PropertyContext = React.createContext({ property: {} });
